import React from 'react';
import { XIcon, TrashIcon } from 'lucide-react';
export const ShoppingCartDrawer = ({
  isOpen,
  onClose,
  selectedProducts,
  productData,
  cartItems,
  onRemoveProduct
}) => {
  if (!isOpen) return null;
  // Use cartItems if available, otherwise fallback to the old method
  const displayItems = cartItems && cartItems.length > 0 ? cartItems : Object.entries(selectedProducts).filter(([_, isSelected]) => isSelected).map(([productType]) => {
    // Find the first product of each selected type
    const product = productData[productType]?.[0];
    return product ? {
      type: productType,
      ...product
    } : null;
  }).filter(Boolean);
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end" data-id="element-488">
      <div className="bg-white rounded-t-xl w-full p-6 max-h-[85vh] overflow-y-auto animate-slide-up" data-id="element-489">
        <div className="flex justify-between items-center mb-4" data-id="element-490">
          <h2 className="text-xl font-bold" data-id="element-491">Selected Products</h2>
          <button onClick={onClose} className="p-1" data-id="element-492">
            <XIcon size={24} data-id="element-493" />
          </button>
        </div>
        {displayItems.length === 0 ? <p className="text-gray-500 text-center py-6" data-id="element-494">Your cart is empty</p> : <>
            {displayItems.map((item, index) => <div key={index} className="border rounded-lg p-4 mb-4" data-id="element-495">
                <div className="flex justify-between items-start" data-id="element-496">
                  <div data-id="element-497">
                    <h3 className="font-bold" data-id="element-498">{item.name}</h3>
                    <p className="text-gray-700" data-id="element-499">{item.description}</p>
                    {item.type === 'savings' && <p className="text-gray-700 mt-1" data-id="element-500">
                        Open your savings account and you become part owner of
                        Pinnacle - with all the benefits of membership.
                      </p>}
                  </div>
                  <button onClick={() => onRemoveProduct(item)} className="text-red-500 p-1" aria-label="Remove from cart" data-id="element-501">
                    <TrashIcon size={20} data-id="element-502" />
                  </button>
                </div>
              </div>)}
            <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium mt-4" onClick={onClose} data-id="element-503">
              Continue with Selection
            </button>
          </>}
      </div>
    </div>;
};